import styled from 'styled-components';
import { darken } from 'polished';
import { withStyles } from '@material-ui/core/styles';
import HelpIcon from '@material-ui/icons/HelpOutline';
//
import MenuItem from 'components/menu-item';
import colors from 'theme/colors';

const { darkBackgroundElevation1, labelPlatinum, white, yellow, black60 } = colors;

export const TabContainer = styled.div({
  display: 'flex',
  flex: 1,
  alignItems: 'center',
  height: '100%',
});

const darkenValue = 0.2;

export const Tab = styled.div<{ isActive: boolean }>`
  align-items: center;
  background-color: ${props => (props.isActive ? darkBackgroundElevation1 : 'transparent')};
  color: ${props => (props.isActive ? white : black60)};
  display: flex;
  font-size: 18px;
  font-weight: 600;
  height: 100%;
  justify-content: center;
  margin: 0;
  padding: 0px 28px;
  position: relative;
  transition: color 0.2s ease;

  :after {
    top: 80%;
    left: 50%;
    border: solid transparent;
    content: ' ';
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
    border-bottom-color: ${props => (props.isActive ? yellow : 'transparent')};
    border-width: 6px;
    margin-left: -6px;
  }

  :hover {
    color: ${darken(darkenValue, white)};
    cursor: pointer;
  }
`;

export const LogoContainer = styled.div({
  width: 80,
  display: 'flex',
  justifyContent: 'center',
});

export const HeaderButtons = styled.div({
  display: 'flex',
  justifyContent: 'flex-end',
  paddingRight: 30,
  alignItems: 'center',
});

export const HeaderButtonGroup = styled.div({
  color: labelPlatinum,
  display: 'flex',
  marginLeft: 16,
  alignItems: 'center',
  marginRight: 8,
});

export const MenuItemText = styled.span`
  margin-left: 16px;
`;

export const HeaderIconContainer = styled.div`
  color: ${colors.labelPlatinum};
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 0.2s color ease-in;
  &:hover {
    cursor: pointer;
    color: ${darken(darkenValue, colors.labelPlatinum)};
  }
`;

export const Username = styled.span`
  font-size: 13px;
  font-weight: 600;
  margin-right: 8px;
`;

export const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  transition: color 0.2s ease, fill 0.2s ease;

  :hover {
    cursor: pointer;
    color: ${darken(darkenValue, labelPlatinum)};
  }
`;

export const AddDealContainer = styled.div`
  margin-right: 24px;
`;

export const LogoutMenuItem = withStyles({
  root: {
    color: colors.error,
  },
})(MenuItem);

export const StyledHelpIcon = withStyles({
  root: {
    height: '1.1em',
    width: '1.1em',
  },
})(HelpIcon);
